// extracted by mini-css-extract-plugin
export var container = "typography-bold-module--container--HadDA";
export var standart = "typography-bold-module--standart--3fuHR";
export var desktop = "typography-bold-module--desktop--EpfI2";
export var mobile = "typography-bold-module--mobile--Ve0QE";